﻿VoterFly.Util = {
    getApiResponseMessage(message, data) {

        const contentType = data.getResponseHeader("content-type");
        if (data.responseJSON) {
            if (contentType.indexOf('application/problem+json') != -1) {
                if (data.responseJSON.errors) {
                    // Parse validation errors and present them to the user
                    const errorMessages = [];
                    for (const propertyName in data.responseJSON.errors) {
                        if (data.responseJSON.errors.hasOwnProperty(propertyName)) {
                            if (propertyName) {
                                errorMessages.push(`${propertyName}: ${data.responseJSON.errors[propertyName].join(', ')}`);
                            } else {
                                errorMessages.push(data.responseJSON.errors[propertyName].join(', '));
                            }
                        }
                    }
                    const errorMessage = errorMessages.join('\n');
                    // Present errorMessage to the user (e.g., display in an alert or show on the UI)
                    message += ' ' + errorMessage;
                } else {
                    // Handle other response data
                }
            } else {

                if (data.responseJSON.message) {
                    message += " " + data.responseJSON.message;
                }

            }
        }

        return message;
    }
}